import { useMsal } from '@azure/msal-react';

import { retrieveEndCustomerId } from '@/utils/account';

// SAFETY: support diagnostic for AB#1606703 (hidden Digital Services tab). Renders the ID
// token's endCustomerId claim in the page background colour so it is invisible until the
// user highlights the area under the unit tabs. Remove once the owner-claim mismatch is fixed.
const TokenEndCustomerIdProbe = () => {
  const { instance } = useMsal();
  const account = instance.getActiveAccount();
  const endCustomerId = account ? retrieveEndCustomerId(account) : undefined;

  return (
    <p className="mt-6 text-xs text-[var(--vcdk-color-bg-base)] select-all">endCustomerId: {endCustomerId ?? 'none'}</p>
  );
};

export default TokenEndCustomerIdProbe;
